var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upload Icon"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "white",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "upload_file"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_13108",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 31,
    width: 39,
    height: 38
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 31.9961,
    y: 31.4966,
    width: 37.0068,
    height: 37.0068,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_13108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "upload_file_2",
    d: "M48.9577 60.7937H52.0416V54.3561L54.5087 56.8232L56.6675 54.6259L50.4997 48.4581L44.3319 54.6259L46.5292 56.7847L48.9577 54.3561V60.7937ZM41.248 65.4196C40.3999 65.4196 39.6741 65.1179 39.0707 64.5145C38.4663 63.91 38.1641 63.1838 38.1641 62.3357V37.6645C38.1641 36.8164 38.4663 36.0901 39.0707 35.4857C39.6741 34.8823 40.3999 34.5806 41.248 34.5806H53.5836L62.8353 43.8323V62.3357C62.8353 63.1838 62.5336 63.91 61.9302 64.5145C61.3257 65.1179 60.5995 65.4196 59.7514 65.4196H41.248ZM52.0416 45.3742V37.6645H41.248V62.3357H59.7514V45.3742H52.0416Z",
    fill: "#322F3B"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup37);
export default __webpack_public_path__ + "static/media/Group 37.ea5cba0e59f39c20b6b30ac17577a0ff.svg";
export { ForwardRef as ReactComponent };